import { useSelector } from 'react-redux';
import useTranslations from './useTranslations';

export default function useAutosaveStatus(id) {
  const t = useTranslations();
  const status = useSelector(state => state.state.autosave[id]);

  return status && status.status ? t(status.status) : null;
}
